import { render, staticRenderFns } from "./ClientNew_Addresses.vue?vue&type=template&id=41ccf169&"
import script from "./ClientNew_Addresses.vue?vue&type=script&lang=js&"
export * from "./ClientNew_Addresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports